// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_gatepass,
  delete_gatepass,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  gatepasss: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
};


// Async Thunks for API Calls
export const fetchgatepass = createAsyncThunk(
  "gatepass/fetchgatepass",
  async (
    { page, page_size,user_id,type,method, school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_gatepass(
        page,
        page_size,
        user_id,type,method,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletegatepass = createAsyncThunk(
  "gatepass/deletegatepass",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_gatepass({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const gatepassSlice = createSlice({
  name: "gatepasss",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    setgatepass(state, action) {
      state.gatepasss = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchgatepass.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchgatepass.fulfilled, (state, action) => {
        state.loading = false;
        state.gatepasss = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchgatepass.rejected, (state, action) => {
        state.loading = false;
        state.gatepasss =[]
        state.error = action.payload;
      })
      // Delete Class
      .addCase(deletegatepass.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletegatepass.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletegatepass.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setgatepass,
  setActivePage,
  setSchoolId,
  setPageSize,

} = gatepassSlice.actions;
export default gatepassSlice.reducer;
